import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
import { BenchmarkCard } from "./BenchmarkCard";
import { TimeOfDayLegend } from "./TimeOfDayLegend";
import { TimeOfDayHeatmapColumn } from "./TimeOfDayHeatmapColumn";
export const TimeOfDayStatsByLevelPanel = ({ options, title = "Non-conformities by time of the day", }) => {
    const [loading, setLoading] = useState(false);
    const [levelData, setLevelData] = useState([]);
    const levelMax1 = useMemo(() => Math.max(...levelData.map((x) => x.Level1), 0), [levelData]);
    const levelMax2 = useMemo(() => Math.max(...levelData.map((x) => x.Level2), 0), [levelData]);
    const levelMax3 = useMemo(() => Math.max(...levelData.map((x) => x.Level3), 0), [levelData]);
    const levelMax4 = useMemo(() => Math.max(...levelData.map((x) => x.Level4), 0), [levelData]);
    useEffect(() => {
        if (!options.isReady)
            return;
        setLevelData([]);
        setLoading(true);
        const params = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            fleets: options.fleet.map((f) => f.ID).join(","),
        });
        fetch(`/api/levelsbenchmark/timeofdaystat?${params.toString()}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((stats) => {
            setLevelData(stats);
        })
            .catch(() => {
            notifyError("An error has occurred when loading non-conformities by time of day. Please try again.");
        })
            .finally(() => {
            setLoading(false);
        });
    }, [
        options.isReady,
        options.startDate,
        options.endDate,
        options.vesselTypes.join(","),
        options.fleet.map((fleet) => fleet.ID).join(","),
    ]);
    return (_jsx(BenchmarkCard, { title: title, children: loading ? (_jsx(WkoLoadingSpinner, {})) : levelData.length === 0 ? (_jsx("div", { className: "py-5", children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) })) : (_jsxs("div", { className: "w-100", children: [_jsx("div", { className: "mb-1", children: "Level 1" }), _jsx("div", { className: "d-flex flex-wrap row g-0", children: levelData.map((data) => (_jsx(TimeOfDayHeatmapColumn, { index: data.Index, topValue: data.Level1, topMaxValue: levelMax1, bottomValue: data.Level2, bottomMaxValue: levelMax2 }, `top-${data.Index}`))) }), _jsx("div", { className: "mb-1", children: "Level 2" }), _jsx("div", { className: "mb-1", children: "Level 3" }), _jsx("div", { className: "d-flex flex-wrap row g-0", children: levelData.map((data) => (_jsx(TimeOfDayHeatmapColumn, { index: data.Index, topValue: data.Level3, topMaxValue: levelMax3, bottomValue: data.Level4, bottomMaxValue: levelMax4 }, `bottom-${data.Index}`))) }), _jsx("div", { className: "mb-1", children: "Level 4" }), _jsx(TimeOfDayLegend, { children: "Darker colours indicate greater frequency of NCs during that time of the day" })] })) }));
};
